import React, { useState, useEffect } from 'react';
import { Typography } from 'antd';

const { Text } = Typography;

interface IntelligentCollectionHeaderProps {
  hasConfigurations?: boolean;
}

const IntelligentCollectionHeader: React.FC<IntelligentCollectionHeaderProps> = ({
  hasConfigurations = false,
}) => {
  // Collapse by default if configurations exist, expand if no configurations
  const [isExpanded, setIsExpanded] = useState(!hasConfigurations);

  // Update the expanded state when configurations are added/removed
  useEffect(() => {
    setIsExpanded(!hasConfigurations);
  }, [hasConfigurations]);

  return (
    <div style={{ padding: '12px 16px' }}>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          marginBottom: 8,
        }}
      >
        <span
          style={{ fontSize: '20px', fontWeight: '500' }}
          data-test-id="intelligentCollectionHeader"
        >
          Intelligent Collection - Network Requests
        </span>
      </div>

      <div style={{ width: '100%', marginTop: 8, marginBottom: 10 }}>
        <Text
          style={{ fontSize: '14px', color: 'rgba(119, 119, 119, 1)', fontWeight: 400 ,width: '95%'}}
          data-test-id="intelligentCollectionDescription"
        >
          Intelligent Collection optimizes the volume of network request collection by overriding
          the default URL blocklist with the Collect/Block rules. Configure the rule using hostname,
          path, or scheme-based filters for collecting a specific set of network requests. If
          needed, use the response codes and duration-based filters for more granular-level
          collection.
        </Text>

        {isExpanded && (
          <>
            <div style={{ marginTop: 12 }}>
              <Text
                style={{
                  fontSize: '14px',
                  color: 'rgba(31, 31, 31, 1)',
                  fontWeight: 400,
                  display: 'block',
                }}
              >
                Benefits:
              </Text>
              <ul style={{ margin: '4px 0 0 0', paddingLeft: '20px' }}>
                <li style={{ fontSize: '14px', color: 'rgba(119, 119, 119, 1)', fontWeight: 400 }}>
                  Controlled Costs – Store and process only meaningful data, optimizing resource
                  utilization.
                </li>
                <li style={{ fontSize: '14px', color: 'rgba(119, 119, 119, 1)', fontWeight: 400 }}>
                  Optimized Performance – Smaller datasets mean faster insights and lower latency.
                </li>
                <li style={{ fontSize: '14px', color: 'rgba(119, 119, 119, 1)', fontWeight: 400 }}>
                  Enhanced Insights – Eliminating noise helps surface key trends and anomalies.
                </li>
                <li style={{ fontSize: '14px', color: 'rgba(119, 119, 119, 1)', fontWeight: 400 }}>
                  System Integrity – Prevents overloading downstream systems with redundant data.
                </li>
              </ul>
            </div>

            <div style={{ marginTop: 12 }}>
              <Text
                style={{
                  fontSize: '14px',
                  color: 'rgba(31, 31, 31, 1)',
                  fontWeight: 400,
                  display: 'block',
                }}
              >
                Supported Platforms and Sensor Versions:
              </Text>
              <ul style={{ margin: '4px 0 0 0', paddingLeft: '20px' }}>
                <li style={{ fontSize: '14px', color: 'rgba(119, 119, 119, 1)', fontWeight: 400 }}>
                  Android 1.1.0 and above
                </li>
                <li style={{ fontSize: '14px', color: 'rgba(119, 119, 119, 1)', fontWeight: 400 }}>
                  Web (JavaScript) 1.1.1 and above
                </li>
                <li style={{ fontSize: '14px', color: 'rgba(119, 119, 119, 1)', fontWeight: 400 }}>
                  iOS 1.0.1 and above
                </li>
              </ul>
            </div>
          </>
        )}

        <div style={{ marginTop: 8 }}>
          <span
            onClick={() => setIsExpanded(!isExpanded)}
            style={{
              color: 'rgba(0, 70, 255, 1)',
              fontSize: '14px',
              fontWeight: 500,
              cursor: 'pointer',
              textDecoration: 'none',
            }}
            data-test-id="view-more-less-toggle"
          >
            {isExpanded ? 'View Less' : 'View More'}
          </span>
        </div>
      </div>
    </div>
  );
};

export default IntelligentCollectionHeader;
